<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>热更新</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content" style="margin:5px">
      <!-- <el-alert type="error" effect="dark" show-icon :closable="false" style="margin-top: 5px; margin-bottom: 5px;">
        <template slot="title">
          <span style="font-size: 15px; font-weight: bold;">
            📢 9月29日01:00点将升级下载服务器，届时下载功能将不可用（预计1小时）。升级后，下载域名将会发生变化；
          </span>
        </template>
      </el-alert> -->
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle :loading="state" @click="refresh"></el-button>
          <el-button type="primary" size="small" class="icon-copy" @click="addHotUpdate">新增热更新<i class="iconfont icon-yunshangchuan"></i></el-button>
        </el-card>
      </div>

      <el-table :data="hotUpdateList" v-loading="loading"  style="width: 100%"  stripe>
        <el-table-column prop="floder_name" label="文件夹">
          <template slot-scope="scope">
            <svg class="icon" aria-hidden="true" v-if="scope.row.hasData == true">
              <use xlink:href="#icon-weibiaoti-_huabanfuben"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-if="scope.row.hasData == false">
              <use xlink:href="#icon-wenjianjia"></use>
            </svg>
            <div class="incologo-title">
              <span class="incologo" >{{scope.row.floder_name}}</span>
            </div>
          </template>
          
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>
        <el-table-column prop="updatedAt" label="修改时间"></el-table-column>
        <el-table-column prop="floder_size" label="大小"></el-table-column>
        <el-table-column label="操作" width="190">
          <template slot-scope="scope">
            <el-button icon="el-icon-setting" type="primary" size="mini" @click="manage(scope.row)">管理</el-button>
            <el-button icon="el-icon-delete" type="danger" size="mini" @click="delHotUpdate(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 新增热更新项目 -->
    <el-dialog title="新增热更新软件" :close-on-click-modal="false" :visible.sync="addDialogVisible" :width="addHotUpdateWidth" @close="closeAddDiaLog">
      <el-form :model="addHotUpdateForm" :rules="addHotUpdaterules" ref="addHotUpdateFormRef" label-width="110px" class="demo-ruleForm" size="small">
        <el-form-item label="软件" prop="softName">
          <el-select v-model="addHotUpdateForm.softName" placeholder="请选择软件" clearable @change="changeInput">
            <el-option v-for="item in allSoftName" :key="item.id" :label="item.softName" :value="item.softName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createHotUpdate" :loading="state">添 加</el-button>
      </span>
    </el-dialog>

    <!-- 管理热更新 -->
    <el-dialog :title="currentHotUpdate.floder_name" :close-on-click-modal="false" :visible.sync="hotupdateDialogVisible" :width=manageHotUpdateWidth :before-close="handleClose">
      <div class="upload-container">
        <el-upload class="upload-demo" ref="upload" drag multiple action="void" :limit="50" :auto-upload="true" 
        :http-request="customUpload" :file-list="fileList" :on-change="handleChange" :on-remove="handleRemove">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传.exe/.apk/.txt/.js/.html/.css/.lua/.luae/.lr/.lrj/.py/.pyd/.pyc/.cpp/.dll/.c/.java/.xml/.lc/.md5/.rtd/.uip/.ice/.zip单个文件不超过20MB</div>
          <div class="el-upload__tip" slot="tip" style="color:red">这只是热更新，不是网盘，不是网盘，不是网盘。所有文件各位保存好，以免文件丢失</div>
          <div class="el-upload__tip" slot="tip" style="color:#008CFF">小技巧：覆盖文件，下载地址不变</div>
        </el-upload>
      </div>

      <el-button type="danger" size="small" @click="multipleDelFile" class="operation" :loading="state" icon="el-icon-copy-document" style="margin-top:10px">批量删除</el-button>

      <el-table :data="hotUpdateFileList" v-loading="loading"  style="width: 100%" stripe  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="file_name" label="文件">
          <template slot-scope="scope">
            <svg class="icon" aria-hidden="true" v-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.txt'">
              <use xlink:href="#icon-wenjianleixing-wenben"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.exe'">
              <use xlink:href="#icon-EXEwenjian3"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.zip'">
              <use xlink:href="#icon-wenjianleixing-zip"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.rar'">
              <use xlink:href="#icon-wenjianleixing-zip"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.tx'">
              <use xlink:href="#icon-wenjianleixing-ts"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.js'">
              <use xlink:href="#icon-wenjianleixing-js"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.css'">
              <use xlink:href="#icon-wenjianleixing-css"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.html'">
              <use xlink:href="#icon-htmlwenjian"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.xml'">
              <use xlink:href="#icon-xml"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.lua'">
              <use xlink:href="#icon-lua"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.json'">
              <use xlink:href="#icon-JSON"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.c'">
              <use xlink:href="#icon-CEB"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.java'">
              <use xlink:href="#icon-java"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.dll'">
              <use xlink:href="#icon-dll"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.py'">
              <use xlink:href="#icon-pythonwenjian"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.pyd'">
              <use xlink:href="#icon-pythonwenjian"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.pyc'">
              <use xlink:href="#icon-pythonwenjian"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.cpp'">
              <use xlink:href="#icon-cpp"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.lr'">
              <use xlink:href="#icon-lr-ract"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else-if="scope.row.file_name.substring(scope.row.file_name.lastIndexOf('.')) == '.lrj'">
              <use xlink:href="#icon-lr-ract"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-else>
              <use xlink:href="#icon-wenjianleixing-fujian"></use>
            </svg>
            <div class="incologo-title">
              <span class="incologo" >{{scope.row.file_name}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="url" label="下载地址" width="140">
          <template slot-scope="scope">
            <div class="contain">
              <el-popover placement="top-start"  trigger="hover" :content="scope.row.url">
                <el-button slot="reference" type="text" size="small" style="margin-left:0px">查看</el-button>
              </el-popover>
              <el-button type="text" size="small" class="icon-copy" v-clipboard:copy="scope.row.url" v-clipboard:success="onCopy">复制</el-button>
              <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定重置下载链接 ？" @confirm="reSet(scope.row.url)">
                <el-button slot="reference" type="text" size="small" >重置</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="createdAt" label="创建时间" width="165"></el-table-column>
        <el-table-column prop="updatedAt" label="修改时间" width="165"></el-table-column>
        <el-table-column prop="file_size" label="大小" width="120"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" type="danger" size="mini" @click="delHotUpdateFile(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleFileSizeChange"
        @current-change="handleFileCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="fileTotal"
      >
      </el-pagination>
    </el-dialog>

    <!-- 删除热更项目的Dialog -->
    <el-dialog title="确定要删除此热更项目？" :close-on-click-modal="false" :visible.sync="delHotUpdateDialog" :width="diaLogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要删除此热更项目？<br></span>
      </div>
      <div style="margin-left:30px;margin-bottom:20px"><span>{{ this.delHotUpdateData.floder_name }}</span></div>
      <span style="margin-left:30px">* 删除热更项目，该热更项目的文件都会被删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delHotUpdateDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="delHotUpdateDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  data(){
    return{
      state:false,
      loading:true,
      hotUpdateList:[],
      queryInfo: {
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
      },
      queryFileInfo: {
        pagenum: 1,
        pagesize: 10,
      },
      total:0,
      addHotUpdateWidth:'500px',
      addDialogVisible: false,
      addHotUpdateForm:{},
      addHotUpdaterules:{},
      allSoftName:"",
      hotupdateDialogVisible: false,
      currentHotUpdate:"",
      manageHotUpdateWidth: '1200px',
      fileList:[],
      hotUpdateFileList:[],
      fileTotal: 0,
      delHotUpdateDialog: false,
      diaLogWidth: '500px',
      delHotUpdateData:"",
      multipleArr: []
    }
  },
  created(){
    if (this.isMobile()){
      this.addHotUpdateWidth = '100%'
      this.manageHotUpdateWidth = '100%'
      this.diaLogWidth = '100%'
    }
    this.getCardTypeSoftName()
    this.getHotUpdate()
  },
  methods:{
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // localStorage.setItem('isiphone',flag)
      //console.log(flag)
      return flag;
    },
    refresh(){
      this.getHotUpdate()
    },
    async getOneHotUpdateFile(){
      this.state = true
      const result = await axios.post(this.$download+"/getonehotupdatefile", {currentHotUpdate: this.currentHotUpdate, queryFileInfo: this.queryFileInfo});
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.fileTotal = result.data.data.total
      this.hotUpdateFileList = result.data.data.allFiles
      if (this.fileTotal > 0) {
        this.hotUpdateFileList = this.hotUpdateFileList.filter((item) => {
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          item.file_size = this.sizeToStr(parseInt(item.file_size))
          item.url = this.$download+"/download?"+ item.url
          if (item.file_size == 0) {
            item.hasData = false
          }else{
            item.hasData = true
          }
          return item
        });
      }else{
        this.hotUpdateFileList = []
      }
    },

    async getHotUpdateFile(){
      this.state = true
      const result = await axios.post(this.$download+"/gethotupdatefile", {currentHotUpdate: this.currentHotUpdate, queryFileInfo: this.queryFileInfo});
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.fileTotal = result.data.data.total
      this.hotUpdateFileList = result.data.data.allFiles
      if (this.fileTotal > 0) {
        this.hotUpdateFileList = this.hotUpdateFileList.filter((item) => {
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          item.file_size = this.sizeToStr(parseInt(item.file_size))
          item.url = this.$download+"/download?"+ item.url
          if (item.file_size == 0) {
            item.hasData = false
          }else{
            item.hasData = true
          }
          return item
        });
      }else{
        this.hotUpdateFileList = []
      }
      // console.log("this.hotUpdateFileList:",this.hotUpdateFileList);
    },
    async getHotUpdate(){
      this.state = true
      const result = await axios.post(this.$download+"/gethotupdate", this.queryInfo);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.hotUpdateList = result.data.data.dataArr
      this.total = result.data.data.total
      if (this.total > 0) {
        this.hotUpdateList = this.hotUpdateList.filter((item) => {
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          item.floder_size = this.sizeToStr(parseInt(item.floder_size))
          if (item.floder_size == 0) {
            item.hasData = false
          }else{
            item.hasData = true
          }
          return item
        });
      }else{
        this.hotUpdateList = []
      }
      // console.log("this.hotUpdateList:",this.hotUpdateList);
      this.loading = false
    },
    addHotUpdate(){
      this.addDialogVisible = true
    },
    async createHotUpdate(){
      this.state = true
      const result = await this.$http.post("addhotupdate", this.addHotUpdateForm);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.addDialogVisible = false
      this.$refs.addHotUpdateFormRef.resetFields()
      this.getHotUpdate()
    },
    handleSizeChange(val){
      this.queryInfo.pagesize = val
      this.getHotUpdate()
    },
    handleCurrentChange(val){
      this.queryInfo.pagenum = val
      this.getHotUpdate()
    },
    handleFileSizeChange(val){
      this.queryFileInfo.pagesize = val
      this.getHotUpdateFile()
    },
    handleFileCurrentChange(val){
      this.queryFileInfo.pagenum = val
      this.getHotUpdateFile()
    },
    closeAddDiaLog(){
      this.$refs.addHotUpdateFormRef.resetFields()
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {});
      this.state = false
      this.allSoftName = result.data.data.result.map(element => {
        return {id: element._id, softName:element.softName}
      })
    },
    changeInput(e){
      this.$forceUpdate()
      for (let index = 0; index < this.allSoftName.length; index++) {
        if (e == this.allSoftName[index].softName) {
          this.addHotUpdateForm.id = this.allSoftName[index].id
        }
      }
    },
    manage(value){
      this.hotupdateDialogVisible = true
      console.log("value:",value);
      this.currentHotUpdate = value
      this.getHotUpdateFile()
    },
    delHotUpdate(value){
      this.delHotUpdateData = value
      this.delHotUpdateDialog = true
    },
    async delHotUpdateDialogBtn(){
      this.state = true
      const result = await axios.post(this.$download+"/delfolder", this.delHotUpdateData);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.delHotUpdateDialog = false
      this.getHotUpdate()
    },
    handleClose(){
      this.hotupdateDialogVisible = false
      this.multipleArr = []
      this.getHotUpdate()
    },
    handleChange(){

    },
    handleSelectionChange(val){
      console.log("选中的val:",val);
      this.multipleArr = val
    },
    async multipleDelFile(){
      this.state = true
      const result = await axios.post(this.$download+"/delmultiplefile", this.multipleArr);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.getHotUpdateFile()
    },
    async delHotUpdateFile(value){
      this.state = true
      const result = await this.$http.post(this.$download+"/delfile", value);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.getHotUpdateFile()
    },
    customUpload(file) {
        let FormDatas = new FormData();
        FormDatas.append('file', file.file);
        const encodedFileName = window.btoa(encodeURIComponent(file.file.name));
        axios({
          headers: {
            'flodername': window.btoa(encodeURIComponent(this.currentHotUpdate.floder_name)),
            'real-filename': encodedFileName, // 💡 把编码后的文件名通过 headers 传过去
            'Content-Type': 'multipart/form-data; charset=UTF-8'
          },
          url: this.$download+'/upload',
          method: 'post',
          data: FormDatas,
          //上传进度
          onUploadProgress: (progressEvent) => {
            let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
            file.onProgress({percent: num})     //进度条
          }
        }).then(data => {
          if (data.data.code && data.data.code == 400) {
            this.$notify.error({title: '错误',message:data.data.message});
            return
          }
          if (data.data.code) {
            this.$notify.error({title: '错误',message:"单文件超出20MB"});
            return
          }
          if (data.data.meta.status !== 200) {
            this.$notify.error({title: '空间已满',message:data.data.meta.msg});
            return
          }
          file.onSuccess(); //上传成功(打钩的小图标)
          this.getOneHotUpdateFile()
          console.log("上传成功的回调");
        }).catch(error => {
          // 💡 核心修复：在这里精准捕获服务器返回的 413 (Payload Too Large) 错误
          if (error.response && error.response.status === 413) {
            this.$notify.error({ title: '错误', message: "单文件超出20MB限制" });
          } else {
            this.$notify.error({ title: '错误', message: "文件上传失败，请稍后重试" });
          }
        });
    },
    /**     文件正在上传时的钩子    **/
    progressA(event, file) {},
    /**     移除上传文件    **/
    handleRemove(file) {
      this.$refs.upload.abort(); //取消上传
      this.$message({message: '成功移除' + file.name, type: 'success'});
    },
    onCopy(e) {
      this.$message.success('已复制到剪贴板!')
    },
    async reSet(val){
      console.log("val:",val);
      this.state = true
      const result = await axios.post(this.$download+"/reset", {url:val});
      console.log("result:",result);
      this.state = false
      this.getHotUpdateFile()
    },
    sizeToStr(limit){
      let size = "";
      if(limit < 0.1 * 1024){
        size = limit.toFixed(2) + "B";        //小于0.1KB，则转化成B
      }else if(limit < 0.1 * 1024 * 1024){
        size = (limit / 1024).toFixed(2) + "KB";        //小于0.1MB，则转化成KB
      }else if(limit < 0.1 * 1024 * 1024 * 1024){
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";        //小于0.1GB，则转化成MB
      }else{
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";        //其他转化成GB
      }
      let sizeStr = size + "";                        //转成字符串
      let index = sizeStr.indexOf(".");                    //获取小数点处的索引
      let dou = sizeStr.substr(index + 1 ,2)            //获取小数点后两位的值
      if(dou == "00"){                                //判断后两位是否为00，如果是则删除00                
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.navbtn{
  margin-bottom: 20px;
}

.icon {
  width: 2.5em;
  height: 2.5em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  vertical-align: middle;
  margin-right: 15px;
}

.iconfont{
  display: inline-block;
  margin-right: 0;
  height: 14px;
  vertical-align: bottom;
}

.upload-container{
  /deep/ .el-upload{
    width: 100%;
  }
  /deep/ .el-upload .el-upload-dragger{
    width: 100%;
  }
}


.incologo{
  height: 2.5em;
  display: inline-block;
  // margin-top: 10px;
  // padding-top: 10px;
  padding: 0 0 0 0;
}

.incologo-title{
  height: 100%;
  display: inline-block; 
  // overflow: hidden;
  // padding:1px 1px 1px 1px;
}

.el-table {
  .contain{
    .el-button {
      margin-left: 10px;
      font-size: 14px;
    }
  }
}
// 
</style>
